import { mappedColors, useTheme } from '@pixee/design-system'
import { useMemo } from 'react'
import Confetti from 'react-confetti'
import { getCssVariable } from '../utils/color-utils.ts'

type DrawerConfettiProps = {
  width: number
  height: number
  onComplete: () => unknown
}

export const DrawerConfetti: React.FC<DrawerConfettiProps> = ({ width, height, onComplete }) => {
  const { theme } = useTheme()

  const colors = useMemo(
    () => [
      getCssVariable(mappedColors.primary.nebula),
      getCssVariable(mappedColors.primary.drift),
      getCssVariable(mappedColors.secondary.wave),
    ],
    [theme]
  )

  return (
    <Confetti
      width={width}
      height={height}
      numberOfPieces={200}
      recycle={false}
      gravity={0.7}
      initialVelocityY={25}
      tweenDuration={100}
      colors={colors}
      onConfettiComplete={onComplete}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        pointerEvents: 'none',
        zIndex: 100,
      }}
      confettiSource={{
        x: 0,
        y: 0,
        w: width,
        h: 300,
      }}
    />
  )
}
